import React, { PureComponent } from 'react';
import { csvParse, utcParse, utcYear, nest,  scaleOrdinal,  ascending, max } from 'd3'
import { createSelector } from 'reselect';
//import Selector from './Selector';
import BreakdownPie from './BreakdownPie';
import BreakdownTable from './BreakdownTable';
import { translate } from './translate';
//import Timeline from './Timeline';
//import WidgetTitleBar from './WidgetTitleBar'
import { divergingColors } from './pallette';
import { DATE, SECTOR_HOLDING_NAME, SECTOR_HOLDING_WEIGHT, SECTOR_HOLDING_SECTOR, SECTOR_WEIGHT } from './constants';

const parseDate = utcParse('%-m/%-d/%Y')
const colorScale = scaleOrdinal()
  .range(divergingColors)

const nestedSectorsData = createSelector(
  (props, state) => state.data,
  (props, state) => max(state.data, d => d[DATE].getUTCFullYear()),// find the most recent year
  (data, mostCurrentYear) => nest()
    .key(d => d[DATE].getUTCFullYear() === mostCurrentYear ? 'Current' : d[DATE].getUTCFullYear())
    .key(holding => holding[SECTOR_HOLDING_SECTOR])
    .entries(data)
    .map(period => ({
      ...period,
      values: period.values
        .map(sector => ({
          ...sector, 
          [SECTOR_WEIGHT]:         sector.values[0][SECTOR_WEIGHT],
          [SECTOR_HOLDING_SECTOR]: sector.values[0][SECTOR_HOLDING_SECTOR],
        }))
        .sort((a, b) => ascending(b[SECTOR_WEIGHT], a[SECTOR_WEIGHT]))
    }))
    .sort((a, b) => ascending(a.key, b.key))
)
const selectedPeriodData = createSelector(
  nestedSectorsData,
  (props, state) => state.selectedPeriod,
  (nestedData, selectedPeriod) => nestedData.find(d => d.key === selectedPeriod).values
)

class SectorsWidget extends PureComponent {
  constructor() {
    super()
    this.state = {
      selectedPeriod: 'Current',
      selectedSector: null,
      highlightedSector: null,
      expandedSector: null,
      mouseDate: null,
      data: csvParse(window.fundSectorsData, d => ({
        ...d,
        [DATE]: utcYear.floor(parseDate(d[DATE])),
        [SECTOR_HOLDING_WEIGHT]: +d[SECTOR_HOLDING_WEIGHT],
        [SECTOR_WEIGHT]: +d[SECTOR_WEIGHT]
      })),
    }
    this.handleSelectPeriod = this.handleSelectPeriod.bind(this)
    this.handleSelectSector = this.handleSelectSector.bind(this)
    this.handleHighlightSector = this.handleHighlightSector.bind(this)
    this.handleExpandSector = this.handleExpandSector.bind(this)
    this.handleMouseDate = this.handleMouseDate.bind(this)
  }
  handleSelectPeriod(selectedPeriod) {
    colorScale.domain([])
    this.setState({selectedPeriod})
  }
  handleSelectSector(selectedSector) {
    this.setState({selectedSector})
  }
  handleHighlightSector(highlightedSector) {
    this.setState({highlightedSector})
  }
  handleExpandSector(expandedSector) {
    this.setState({
      expandedSector: expandedSector === this.state.expandedSector ? null : expandedSector
    })
  }
  handleMouseDate(mouseDate) {
    this.setState({mouseDate})
  }
  render() {
    const { width, i18n, lang } = this.props
    const { highlightedSector,  expandedSector } = this.state
    //const nestedData = nestedSectorsData(this.props, this.state)
    return (
      <div className='SectorsWidget' >
        {/*<Selector
          onSelect={this.handleSelectPeriod}
          options={
            nestedData.map( (d, i) => {
              const id = d.key
              return { id: id, label: id }
            })
          }
          selected={selectedPeriod}
        />*/}
        <BreakdownPie
          data={selectedPeriodData(this.props, this.state)}
          width={width}
          nameField={SECTOR_HOLDING_SECTOR}
          weightField={SECTOR_WEIGHT}
          highlighted={highlightedSector}
          onSelect={this.handleSelectSector}
          onHighlight={this.handleHighlightSector}
          colorScale={colorScale}
          innerLabel={translate('SECTORS', i18n, lang)}
        />
        <BreakdownTable
          data={selectedPeriodData(this.props, this.state)}
          nameField={SECTOR_HOLDING_SECTOR}
          weightField={SECTOR_WEIGHT}
          childNameField={SECTOR_HOLDING_NAME}
          childWeightField={SECTOR_HOLDING_WEIGHT}
          highlighted={highlightedSector}
          onSelect={this.handleSelectSector}
          onHighlight={this.handleHighlightSector}
          onExpand={this.handleExpandSector}
          colorScale={colorScale}
          nestedChildren={d => d.values}
          expanded={expandedSector}
          nameColumnLabel={translate('NAME', i18n, lang)}
          weightColumnLabel={translate('WEIGHT_PCT', i18n, lang)}
          sectorHoldingsLabel={translate('SECT_HOLD', i18n, lang)}
          sectorHoldingsTopLabel={translate('SECT_HOLD_TOP', i18n, lang)}
          sectorHoldingsWeightLabel={translate('WEIGHT_HOLD', i18n, lang)}
        />
      </div>
    )
  }
}

export default SectorsWidget


// WEBPACK FOOTER //
// ./src/SectorsWidget.js